export const encrypt = (string) => {
  return window.btoa(string);
};

export const decrypt = (b64) => {
  try {
    return window.atob(b64);
  } catch (error) {
    return error.message;
  }
};
